export var HoverEventType;
(function (HoverEventType) {
    HoverEventType[HoverEventType["none"] = 0] = "none";
    HoverEventType[HoverEventType["show_text"] = 1] = "show_text";
    HoverEventType[HoverEventType["show_item"] = 2] = "show_item";
    HoverEventType[HoverEventType["show_entity"] = 3] = "show_entity";
    //show_achievement?
})(HoverEventType || (HoverEventType = {}));
